import { render, staticRenderFns } from "./ORouteDetails.vue?vue&type=template&id=5ac50472&"
import script from "./ORouteDetails.vue?vue&type=script&lang=js&"
export * from "./ORouteDetails.vue?vue&type=script&lang=js&"
import style0 from "./ORouteDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports